import styled from 'styled-components';
export const BaseSolarisCardWidth = '280px';
export const BaseSolarisCard = styled.div `
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	background-color: ${(props) => props.theme.palette.shade6};
	${(props) => (props.$loading ? 'opacity: 0.6;' : '')}

	width: ${BaseSolarisCardWidth};
	min-height: 300px;
`;
export const StyledHeader = styled.h1 `
	font-size: clamp(3rem, 6vw, 4rem);
	width: 100%;
	margin: 0;
	margin-bottom: ${(props) => props.theme.spacing.xl};
`;
//# sourceMappingURL=StyleUtils.js.map